import React, { useEffect, useState, useRef } from 'react';
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-phone-number-input/style.css'
//core imports
import Snackbar from "components/Snackbar/Snackbar.js";
import Button from "components/CustomButtons/Button.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import MaskReal from 'services/formateRS';
import DatePicker from "components/Datepicker/Datepicker";
//material imports
import AddAlert from "@material-ui/icons/AddAlert";
import Input from '@mui/material/Input';

function ModalAddPaymentSell(props) {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const { storageId, storageUserType } = useAuth();
    const fileInputRef = useRef();
    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [paidValue, setPaidValue] = useState(0);
    const [paymentDate, setPaymentDate] = useState(new Date().withoutTime());
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState();

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.loadPayment();
                        props.onHide();
                    }, 700);
                }
                break;
            default:
                break;
        }
    };

    const handleButtonClick = (e) => {
        e.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Dispara o clique no input
        } else {
            console.error("Ref para o Input não está configurada.");
        }
    };
    async function handleFileUpload(event) {
        setFile(event.target.files[0]);
        setFileName(event.target.files[0].name);
    };
    const handleAddPayment = async (e) => {
        e.preventDefault();
        const new_remaining = props.props.remaining_value - paidValue;
        if (new_remaining < 0) {
            return alert(`Valor de pagamento excede divida.`)
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('id_admin', storageId);
        formData.append('nf', props.props.nf);
        formData.append('id_client', props.props.id_client);
        formData.append('paid_value', paidValue);
        formData.append('remaining_value', props.props.remaining_value - paidValue);
        formData.append('total_value', props.props.total_value);
        formData.append('payment_date', paymentDate);

        const addPayment = await api.post('/payment/sell', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        if (addPayment.status === 200) {
            setControlSnack(true);
        };
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar pagamento
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddPayment}>
                <Modal.Body >
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>VALOR PAGO</Form.Label>
                            <MaskReal value={paidValue} onChange={value => setPaidValue(value.replace(',', '.'))} />
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>DATA</Form.Label>
                            <div>
                                <DatePicker
                                    selected={paymentDate}
                                    onChange={date => setPaymentDate(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>DATA</Form.Label>
                            <div>
                                <Input
                                    type="file"
                                    id="contained-button-file"
                                    placement="top"
                                    inputRef={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileUpload}
                                />
                                <button onClick={handleButtonClick}>Carregar Arquivo</button>
                            </div>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Adicionar
                        </Button>
                    </div>
                    <Snackbar
                        place="br"
                        color="success"
                        icon={AddAlert}
                        message="Região adicionado com sucesso"
                        open={br}
                        closeNotification={() => setBR(false)}
                        close
                    />
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalAddPaymentSell;